import axios from "axios";

const DEV_BACKEND_URL = process.env.REACT_APP_DEV_BACKEND_URL || "http://127.0.0.1:8000";
const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "development" ? DEV_BACKEND_URL : "")
).replace(/\/$/, "");
const BENCHMARK_BACKEND_URL = (
  process.env.REACT_APP_BENCHMARK_BACKEND_URL ||
  BACKEND_URL
).replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;
export const BENCHMARK_API = `${BENCHMARK_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 180000,
});

export const benchmarkApi = axios.create({
  baseURL: BENCHMARK_API,
  timeout: 3600000,
});

export async function fetchNetworks() {
  const { data } = await api.get("/networks");
  return data.networks;
}

export async function fetchAlgorithms() {
  const { data } = await api.get("/algorithms");
  return data;
}

export async function fetchNetworkInfo(networkId) {
  const { data } = await api.get(`/networks/${encodeURIComponent(networkId)}`);
  return data;
}

export async function fetchNetworkTopology(networkId) {
  const { data } = await api.get(`/networks/${encodeURIComponent(networkId)}/topology`);
  return data;
}

export async function calculateDOE(payload) {
  const { data } = await api.post("/doe/calculate", payload);
  return data;
}

export async function runBenchmark(payload) {
  // The generator-bus benchmark runs 4 analytic methods + an OpenDSS
  // equivalent on the server, so it needs a longer timeout than a single DOE.
  const { data } = await api.post("/doe/benchmark", payload, { timeout: 600000 });
  return data;
}

export async function fetchBenchmarkMethods() {
  const { data } = await api.get("/doe/benchmark/methods");
  return data.methods;
}

export async function fetchBenchmarkV2Config() {
  const { data } = await api.get("/doe/benchmark-v2/config");
  return data;
}

export async function runBenchmarkV2(payload) {
  const { data } = await benchmarkApi.post("/doe/benchmark-v2", payload);
  return data;
}
